export const AdminMenuCategoryController = {
    index(): void {},
    store(): void {},
    order(): void {},
    update(): void {},
    bulkDestroy(): void {},
    destroy(): void {},
    move(): void {},
};
